import { FC } from "react";
import { AccountsCounts } from "../common/accounts-count/AccountsCounts";
import { useAppSelector } from "../../../../../../../store/hooks";
import { selectedAccountsCountInAllCategoriesSelector } from "../../../../../../../store/dimensions/selectors/accounts/selectedAccountsCountInAllCategoriesSelector";

export const DimensionAccountsCount: FC = () => {
  const accountsCount = useAppSelector(
    selectedAccountsCountInAllCategoriesSelector,
  );

  return <AccountsCounts accountsCount={accountsCount} />;
};
